import { CardTableDataTree } from '@flint/atoms'
import { getCardTableDataTree as getCardTableDataTreeBase } from './_base'

export const getCardTableDataTree = (props) =>
  getCardTableDataTreeBase({
    ...props,
    DataTree: CardTableDataTree,
  })
